import Network from "./networkHandler/Network";
import {
  AdminInfoDTO,
  GameComplexity,
  GameInfo,
  GameTag,
  GameVersionDTO,
  GameVersionStatus,
  LoginType
} from "../_genApi/gameDeploy";
import ProperGameInfo from "./typedef/ProperGameInfo";
import InvalidProperGameInfo from "./typedef/InvalidProperGameInfo";
import CommonUtil from "./util/CommonUtil";
import Auth from "./auth/auth";
import StringUtil from "./util/StringUtil";
import WindowEventListener from "./WindowEventListener";
import { ListingGameInfo } from "./typedef/ListingGameInfo";

// This variable is no longer needed as we're using a modal approach
// let _opening = false;
export default class GameMgr {

  // Reference to the openGameModal function from the context
  // Will be set by the GameModalProvider when the app initializes
  static openGameModal: ((gameInfo: ProperGameInfo) => void) | null = null;
  
  // Reference to the navigate function for URL updates
  // Will be set by the AllGames component when it initializes
  static navigate: ((path: string) => void) | null = null;

  static searchGame(filter: SearchGameFilter): Promise<ListingGameInfo[]> {
    return Network.withServerUploadGame().searchGame(filter);
  }

  static async openGame(gameInfo: ProperGameInfo) {
    console.log('GameMgr.openGame called with gameInfo:', gameInfo);
    console.log('GameMgr.navigate available:', !!GameMgr.navigate);
    console.log('GameMgr.openGameModal available:', !!GameMgr.openGameModal);

    // Update URL to shareable game URL first
    if (GameMgr.navigate) {
      console.log('Navigating to:', `/dashboards/games/${gameInfo.id}`);
      GameMgr.navigate(`/dashboards/games/${gameInfo.id}`);
      return;
    }

    // Fallback to old behavior if context is not properly set up
    console.warn('GameModal context not initialized, falling back to window.open');
    const playUrl = Network.withServerUploadGame().getServerUrl() + `/game/${gameInfo.id}/game.html`;
    window.open(playUrl, "_blank");
  }

  // This method is kept for backward compatibility but is no longer used directly
  // The same functionality is now handled by the GameModal component
  static postMessageToGameWindowOnLoad(option: {
    gamePreviewWindow: Window,
    messageContent: { token: string, gameId: number, userName: string, loginType: LoginType, avatar: string },
    delayBetweenRetryInMS: number,
    retryCount: number,
  }) {
    let gamePreviewWindow = option.gamePreviewWindow;
    if (!gamePreviewWindow) {
      console.error('WTF gamePreviewWindow missing', gamePreviewWindow);
      return;
    }
    let delayBetweenRetryInMS = option.delayBetweenRetryInMS;
    let retryCount = option.retryCount;

    let success = false;
    const resend = (message: string, attempt: number) => {
      if (success) {
        WindowEventListener.ignoreConfirmation(messageId);
        return;
      }

      if (attempt > 0) {
        console.log('resend with attempt ', attempt, '...');
      }
      gamePreviewWindow.postMessage(
        message,
        Network.withServerUploadGame().getServerUrl() + '/'
      );

      if (attempt >= retryCount) {
        console.warn('RETRY COUNT REACHED', attempt, retryCount, 'wont postMessage any more..');
        WindowEventListener.ignoreConfirmation(messageId);
        return;
      }

      setTimeout(() => {
        attempt++;
        resend(message, attempt);
      }, delayBetweenRetryInMS)
    }

    let attempt = 0;
    let messageId = newMessageId('postMessageToGameWindowOnLoad', 0);

    let stuffToSend = {
      messageId,
      gameId: option.messageContent.gameId,
      ssKey: option.messageContent.token,
      userName: option.messageContent.userName,
      loginType: option.messageContent.loginType,
      avatar: option.messageContent.avatar,
      source: "user",
    };


    WindowEventListener.onConfirmation(messageId, () => {
      console.log('send postmessage success');
      success = true;
    })

    console.log('sending message..', stuffToSend);
    let message = JSON.stringify(stuffToSend);
    resend(message, attempt);
  }

  static async likeGame(gameId: number) {
    console.log('GameMgr.likeGame called with gameId:', gameId);
    await Network.withServerUploadGame().likeGame(gameId);
  }

  static viewGame(gameId: number) {
    console.log('GameMgr.viewGame called with gameId:', gameId);
    Network.withServerUploadGame().viewGame(gameId);
  }

  static markGameEnd(gameId: number) {
    Network.withServerUploadGame().markGameEnd(gameId);
  }
  
  /**
   * Log the play time of a game
   * @param gameId The ID of the game
   * @param playTimeInSeconds The play time in seconds
   */
  static async logGamePlayTime(gameId: number, playTimeInSeconds: number) {
    console.log(`GameMgr: Logging play time for game ${gameId}: ${playTimeInSeconds} seconds`);
    await Network.withServerUploadGame().logGamePlayTime(gameId, playTimeInSeconds);
  }
}
function newMessageId (signature, attempt) {
  return 'GameMgr-' + signature + '-' + StringUtil.randomString() + "-" + Date.now() + "-" + attempt;
}

export type SearchGameFilter = {
  keyword?: string,
  complexity?: GameComplexity | 'any',
  numPlayer?: { minPlayer: number, maxPlayer: number } | 'any',
  timePlaying?: { minTime: number, maxTime: number } | 'any', //seconds
  gameTag?: GameTag[] | 'any',
  sort?: string,
  numTake: number;
  capMinId: number;
}
